export default "__VITE_ASSET__BWD2IFP8__"